//For subtotal change----------------------------------------------------------------
$(".quantity__button").on("click", function(){
 fetch_qty();
})

$('.quantity__input').on('keyup', function(){
  fetch_qty();
})

function fetch_qty(){
  max_qty = parseInt($('.quantity__input').attr('max'));
  added = parseInt($(".quantity__input").val());
  if (typeof max_qty !== 'undefined' && max_qty !== false){
  if (added >= max_qty) {
    $('.condition-text1').show();
  } else {
     $('.condition-text1').hide();
  }
}
  update_subtotal();
}

// For product variants--------------------------------------------------------------
function update_field(){
  setTimeout(update_fields, 100);
}

function update_fields(){
  $("#product-price-t").load(location.href + " #product-price-t");
  $("#change").load(location.href + " #change");
  update_subtotal();
}

function update_subtotal(){
    price = $("#product-price-t").val();
    qty = $(".quantity__input").val();
    if (typeof qty == 'undefined' && key !== false){
      qty = 1;
    } 
    subtotal = qty*price ;
    $("#change").text(subtotal.toFixed(2));       
}


$(document).ready(function() {
  $('.spr-starrating').attr("data-tab", "tab-2");
  /*
// For terms & condition checkbox---------------------------------------------------
    $('#choice1-1').change(function() {
        if(this.checked) {
          $('.product-form__submit').prop('disabled', false);
           $('.condition-text').hide();
        }else{ 
           $('.product-form__submit').prop('disabled', true);
          $('.condition-text').show();
        }      
    });*/
});

// For description toggle ----------------------------------------------------------
$('#description-toggle').on('click', function(){
  event.preventDefault();
  $('#description-toggle1').hide();
  $('#description-toggle2').show();
  $('#description-toggle').hide();
});

// For quantity input ---------------------------------------------------------------
$(".quantity__input").blur(function () {
        if ($(this).val() == "") {
            $(this).val(1);
          update_subtotal();
        } 
})
// For slide to reviews functionality-------------------------------------------------
$('.spr-starrating').click(function () {
   
  $('.tabbing-section ul li .nav-link[href="#tab-2"]').click();
    $(function() {
    var target = $('.tabbing-section');
    if (target.length) {
   //   $("html, body").animate({ scrollTop: offset - header_height }, "slow");
       $('html,body').animate({
            scrollTop: target.offset().top
        }, 1000);
        return false;
    }
}); 
  });

